export interface TimeSettings {
  endOfDayHour: number; // 0-23 hour format
  resetHour: number; // 0-23 hour format
}

const DEFAULT_TIME_SETTINGS: TimeSettings = {
  endOfDayHour: 23, // 11 PM
  resetHour: 7, // 7 AM
};

export function saveTimeSettings(settings: TimeSettings): void {
  localStorage.setItem('timeSettings', JSON.stringify(settings));
}

export function loadTimeSettings(): TimeSettings {
  const stored = localStorage.getItem('timeSettings');
  if (!stored) return DEFAULT_TIME_SETTINGS;
  
  try {
    return JSON.parse(stored);
  } catch {
    return DEFAULT_TIME_SETTINGS;
  }
}

export function formatHour(hour: number): string {
  const period = hour >= 12 ? 'PM' : 'AM';
  const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
  return `${displayHour}:00 ${period}`;
}

export function formatTime(date: Date): string {
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const period = hours >= 12 ? 'PM' : 'AM';
  const displayHour = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
  const displayMinutes = minutes.toString().padStart(2, '0');
  return `${displayHour}:${displayMinutes} ${period}`;
}

export function getEndOfDayUTC(endOfDayHour: number): string {
  // Create a date for today at the specified local hour
  const today = new Date();
  const endOfDayLocal = new Date(today.getFullYear(), today.getMonth(), today.getDate(), endOfDayHour, 0, 0);
  
  // Convert to UTC and format as HH:MM
  const utcHours = endOfDayLocal.getUTCHours();
  const utcMinutes = endOfDayLocal.getUTCMinutes();
  return `${utcHours.toString().padStart(2, '0')}:${utcMinutes.toString().padStart(2, '0')}`;
}